import { DynamicObjectInterface } from '../type';
import { AxiosUtilsType, axiosGet, axiosPut } from './axiosUtils';
import './axiosInterceptor';

const LeaderService = {
  async getLeaderByCampaignId(campaignId: string): AxiosUtilsType {
    return await axiosGet(`/leader/campaign?id=${campaignId}`);
  },

  async getLeaderDetailsByRecId(recId: string): AxiosUtilsType {
    return await axiosGet(`/leader/campaign/${recId}`);
  },

  async updateTeamCoachDetails(recId: string, payload: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPut(`/leader/campaign/${recId}?section=${payload?.section}`, payload);
  },
};
export default LeaderService;
